<script>
import axios from 'axios';
import mapSettings from '../../lib/map';
import svg from '../../lib/svg';

export default {
  name: 'floristProfile',
  props: ['fid', 'megamarket', 'juri', 'lat', 'lng', 'children'],
  data() {
    return {
      title: "Mapping System",
      map: null,
      kml: null,
      mlt: null,
      mlng:null,
      mzoom:null,
    }
  },
  mounted(){
      axios.get( zurl +'api/mapping/heatmaps/megamarket/?format=json&jurisdiction='+this.juri+'&name='+this.megamarket).then(response => {
          let res = response.data.results[0];
          this.kml = res.kml;
          this.mlt = res.lat;
          this.mlng = res.lng;
          this.mzoom = res.zoom;
          this.loadMap();
      }).catch(e => {
        console.log(e);
      })
  },
methods:{   
    loadMap(){
        this.map = new google.maps.Map(document.getElementById('map-canvas-'+this.fid), {
            zoom: this.mzoom,
            center: new google.maps.LatLng(this.mlt, this.mlng),
            mapTypeId: 'terrain',
            styles: mapSettings.style
        });
        
        let kmlLayer = new google.maps.KmlLayer(this.kml, {
          suppressInfoWindows: true,
          preserveViewport: true,
          map: this.map,
        });

        this.displayChildren();
        
        this.markers = new google.maps.Marker({
            position: new google.maps.LatLng(this.lat,this.lng),
            map: this.map,
            icon: svg.star()
        });
    },
    displayChildren(){
      var myObj = JSON.parse(this.children);

      for (var key in myObj) {
          //console.log(myObj[key]['fields']['lat']);
          this.markers = new google.maps.Marker({
              position: new google.maps.LatLng(myObj[key]['fields']['lat'],myObj[key]['fields']['lng']),
              map: this.map,
              icon: svg.common(myObj[key]['fields']['company_name'], 'Member')
          });
      }
    }
 }
}
</script>


// WEBPACK FOOTER //
// src/components/mapping/florist-profile.vue